import { StyleSheet } from 'react-native';

import { Theme } from '@constants';

export const styles = StyleSheet.create({
  describeText: {
    marginBottom: Theme.px(24),
    width: Theme.px(910),
  },
  logo: {
    height: Theme.px(150),
    marginBottom: Theme.px(23),
    width: Theme.px(150),
  },
  pageContent: {
    alignItems: 'flex-start',
    flexDirection: 'column',
    justifyContent: 'flex-start',
    marginLeft: Theme.px(120),
    marginTop: Theme.px(128),
  },
  pageSubtitle: {
    marginBottom: Theme.px(110),
    width: Theme.px(910),
  },
  pageTitle: {
    marginBottom: Theme.px(5),
    width: Theme.px(910),
  },
  topButton: {
    marginBottom: Theme.px(66),
  },
});
